var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { faApplePay, faCcAmex, faCcMastercard, faCcVisa, faGooglePay } from '@fortawesome/free-brands-svg-icons';
import { faBan, faCreditCard, faHandHoldingDollar, faMobileSignal, faMoneyBill1, faLink } from '@fortawesome/pro-solid-svg-icons';
import { cleanPhoneNumberFormat } from '@spike/phone-utils';
import last from 'lodash/last';
export var createBusinessProfile = function (marketplace, masterdata, uuid) {
    var address = createAddress(marketplace, masterdata);
    return {
        uuid: uuid(),
        legalName: '',
        tradeName: marketplace.basics.businessName,
        einNumber: '',
        email: marketplace.basics.email,
        website: marketplace.basics.website,
        phoneNumber: cleanPhoneNumberFormat(marketplace.basics.phone),
        termsOfService: false,
        address: __assign({}, address),
        editable: true,
        active: true,
    };
};
export var createAddress = function (marketplace, masterdata) {
    var _a, _b, _c, _d;
    var street = '';
    var streetNumber = '';
    var firstStreetToken = marketplace.basics.address.street.split(' ')[0];
    var lastStreetToken = last(marketplace.basics.address.street.split(' '));
    if (!isNaN(parseInt(firstStreetToken))) {
        streetNumber = firstStreetToken;
        street = marketplace.basics.address.street.substring(firstStreetToken.length);
    }
    else if (!isNaN(parseInt(lastStreetToken || ''))) {
        streetNumber = lastStreetToken || '';
        street = marketplace.basics.address.street.substring(0, marketplace.basics.address.street.length - (lastStreetToken || '').length);
    }
    return {
        street: street,
        streetNumber: streetNumber,
        city: marketplace.basics.address.city,
        zipcode: marketplace.basics.address.zipcode,
        state: ((_a = marketplace.basics.address.country) === null || _a === void 0 ? void 0 : _a.id) === 'US'
            ? (_c = (_b = masterdata.usStates.find(function (state) {
                var _a;
                return state.id === marketplace.basics.address.state ||
                    state.name.toUpperCase() === ((_a = marketplace.basics.address.state) === null || _a === void 0 ? void 0 : _a.toUpperCase());
            })) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : ''
            : (_d = marketplace.basics.address.state) !== null && _d !== void 0 ? _d : '',
        country: masterdata.countryCodes.find(function (countryCode) { return countryCode.alpha2 === marketplace.basics.address.country.id; }),
    };
};
export var createShareholder = function (uuid, marketplace, address, ownerFirstName, ownerLastName) {
    return {
        uuid: uuid(),
        firstName: ownerFirstName || '',
        lastName: ownerLastName || '',
        email: marketplace.basics.email,
        documentNumber: '',
        phoneNumber: cleanPhoneNumberFormat(marketplace.basics.phone),
        address: __assign({}, address),
        editable: true,
        active: true,
    };
};
export var createBankAccount = function (uuid, ownerName, primary) {
    return {
        uuid: uuid(),
        ownerName: ownerName || '',
        accountNumber: '',
        description: '',
        routingNumber: '',
        primary: primary || false,
        editable: true,
        active: true,
        accountIdentifier: null,
        realLastFour: null,
        trustedSource: null,
    };
};
export var DocumentTypeIds;
(function (DocumentTypeIds) {
    DocumentTypeIds["ID"] = "ID";
    DocumentTypeIds["DRIVING_LICENSE"] = "DRIVINGLICENSE";
    DocumentTypeIds["PASSPORT"] = "PASSPORT";
    DocumentTypeIds["SSN"] = "SOCIALSECURITY";
    DocumentTypeIds["VISA"] = "VISA";
})(DocumentTypeIds || (DocumentTypeIds = {}));
export var VerificationStatusIds;
(function (VerificationStatusIds) {
    VerificationStatusIds["PASSED"] = "PASSED";
    VerificationStatusIds["IN_PROGRESS"] = "IN_PROGRESS";
    VerificationStatusIds["AWAITING_DATA"] = "AWAITING_DATA";
    VerificationStatusIds["DATA_PROVIDED"] = "DATA_PROVIDED";
    VerificationStatusIds["PENDING"] = "PENDING";
    VerificationStatusIds["INVALID_DATA"] = "INVALID_DATA";
    VerificationStatusIds["RETRY_LIMIT_REACHED"] = "RETRY_LIMIT_REACHED";
    VerificationStatusIds["FAILED"] = "FAILED";
})(VerificationStatusIds || (VerificationStatusIds = {}));
export var paymentMethodIcons = new Map([
    ['cash', faMoneyBill1],
    ['credit_card', faCreditCard],
    ['free_of_charge', faBan],
    ['other', faHandHoldingDollar],
    ['google_pay', faGooglePay],
    ['apple_pay', faApplePay],
    ['pos', faMobileSignal],
    ['mc', faCcMastercard],
    ['amex', faCcAmex],
    ['visa', faCcVisa],
    ['pay_by_link', faLink],
]);
export var paymentMethodIconsColor = new Map([
    ['cash', '#7A7A7A'],
    ['credit_card', '#7A7A7A'],
    ['free_of_charge', '#000000'],
    ['other', '#7A7A7A'],
    ['google_pay', '#000000'],
    ['apple_pay', '#000000'],
    ['mc', '#F79E1B'],
    ['amex', '#7A7A7A'],
    ['visa', '#1B4F80'],
    ['pay_by_link', '#7A7A7A'],
]);
export var PaymentMethodIds;
(function (PaymentMethodIds) {
    PaymentMethodIds["POS"] = "pos";
    PaymentMethodIds["CreditCard"] = "credit_card";
    PaymentMethodIds["Cash"] = "cash";
    PaymentMethodIds["Other"] = "other";
    PaymentMethodIds["PayByLink"] = "pay_by_link";
})(PaymentMethodIds || (PaymentMethodIds = {}));
var excludedPaymentMethods = ['google_pay', 'apple_pay'];
var excludePaymentsDisabled = ['credit_card', 'pos', 'pay_by_link'];
export var getPaymentMethods = function (masterData, paymentsEnabled) {
    return masterData.paymentTypes.filter(function (paymentType) {
        return !excludedPaymentMethods.includes(paymentType.id) &&
            (paymentsEnabled || !excludePaymentsDisabled.includes(paymentType.id));
    });
};
